import * as React from 'react'

import { Button } from '../../button/Button'
import { Heading } from '../../heading/Heading'
import { Text } from '../../text/Text'
import { AlertDialog } from '../AlertDialog'
import { AlertDialogIcon } from './AlertDialogIcon'
import type { alert } from './types'

type AlertDialogContentProps = React.ComponentProps<typeof AlertDialog> & {
  className?: string
  onClose: () => void
} & alert

export const Alert = ({
  title,
  size,
  theme,
  description,
  onAction,
  cancelActionText,
  confirmActionText,
  onClose,
  confirmElement,
  cancelElement,
  ...remainingProps
}: AlertDialogContentProps) => (
  <AlertDialog defaultOpen>
    <AlertDialog.Content
      size={size}
      onEscapeKeyDown={(e) => e.preventDefault()}
      onCloseAutoFocus={onClose}
      {...remainingProps}
      className="flex max-h-[90vh] flex-col gap-8"
    >
      <div className="flex items-center gap-2">
        {theme && <AlertDialogIcon theme={theme} />}
        <Heading as={AlertDialog.Title} size="sm" className="mr-4">
          {title}
        </Heading>
      </div>
      {description && (
        <Text as={AlertDialog.Description} className="flex overflow-y-auto">
          {description}
        </Text>
      )}
      <div className="flex flex-wrap justify-end gap-2">
        <AlertDialog.Cancel asChild>
          {cancelElement ||
            (cancelActionText && (
              <Button
                size="sm"
                appearance="outline"
                onClick={() => onAction?.(false)}
              >
                {cancelActionText}
              </Button>
            ))}
        </AlertDialog.Cancel>
        <AlertDialog.Action asChild>
          {confirmElement || (
            <Button size="sm" onClick={() => onAction?.(true)}>
              {confirmActionText}
            </Button>
          )}
        </AlertDialog.Action>
      </div>
    </AlertDialog.Content>
  </AlertDialog>
)
